import { sql } from "drizzle-orm";

import type { WsTranscription } from "@storyboard/web-client";
import { bulkInsert } from "@/db/bulkInsert";
import { transcription } from "@/db/schema";
import { deduplicateByKeyValue } from "@/models/appSyncFunctions.ts";
import { emitTableUpdates } from "../eventing/TableEventManager";

function transformWsTranscription(r: WsTranscription) {
  return {
    id: r.id,
    createdAt: r.createdAt,
    contentId: r.contentId,
    transcriptionContent: r.transcription,
    transcriptionType: r.transcriptionType,
    backendModel: r.model,
    confidence: r.confidence?.toString(),
    executionTime: r.executionTime?.toString(),
    language: r.language,
    priority: r.priority,
    url: r.url,
    translatedFrom: r.translatedFrom,
    format: r.format,
  };
}

export async function bulkUpsertWsTranscriptions(transcriptionRecords: WsTranscription[], deferEmit = false) {
  const dataSet = transcriptionRecords.map((r) => transformWsTranscription(r));
  const deduped = deduplicateByKeyValue(dataSet, (item) => item.id);

  await bulkInsert(transcription, deduped, {
    onConflict: {
      type: "doUpdate",
      target: [transcription.id],
      set: {
        transcriptionContent: sql`excluded."transcriptionContent"`,
        createdAt: sql`excluded."createdAt"`,
        contentId: sql`excluded."contentId"`,
        transcriptionType: sql`excluded."transcriptionType"`,
        backendModel: sql`excluded."backendModel"`,
        confidence: sql`excluded."confidence"`,
        executionTime: sql`excluded."executionTime"`,
        language: sql`excluded."language"`,
        priority: sql`excluded."priority"`,
        url: sql`excluded."url"`,
        translatedFrom: sql`excluded."translatedFrom"`,
        format: sql`excluded."format"`,
      },
    },
  });
  if (!deferEmit) {
    emitTableUpdates(["transcription"]);
  }
}
